import React from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const MerchantGroupSelect = ({
    value,
    onChange,
    merchantGroups,
    loading,
    searchType,
    setSearchType,
    searchTerm,
    setSearchTerm,
    debouncedSearch,
    error,
    edit
}) => {

    return (
        <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm={3}>
                Merchant Group <span className='text-danger'>*</span>
            </Form.Label>
            <Col sm={9}>
                <Dropdown
                    className="w-100"
                    onToggle={(nextShow) => {
                        // When the dropdown closes, clear the parent's search term
                        if (!nextShow && typeof setSearchTerm === 'function') {
                            setSearchTerm('');
                        }
                    }}
                >
                    <Dropdown.Toggle
                        variant='light'
                        className={`form-select text-start ${styles.noCaret} w-100 ${error ? 'is-invalid' : ''}`}
                        id='merchant-group-select'
                        disabled={loading}
                    >
                        {value
                            ? edit ? value : merchantGroups.find(g => g.id === value)?.id
                            : 'Select a merchant group'}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.dropdownMenu}>
                        <div className={styles.searchContainer}>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    size='sm'
                                    as="select"
                                    className='form-select'
                                    value={searchType}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setSearchType(val);
                                        // search will be triggered by parent when search term or type changes
                                    }}
                                    style={{ width: 'auto' }}
                                >
                                    <option value="id">ID</option>
                                    <option value="description">Description</option>
                                </Form.Control>
                                <Form.Control
                                    size='sm'
                                    type='text'
                                    placeholder='Search merchant groups...'
                                    value={searchTerm}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setSearchTerm(val);
                                        // parent will handle debounced fetching via the search term state
                                    }}
                                />

                            </div>
                        </div>
                        <div className={styles.scrollableMenu}>
                            {merchantGroups.length === 0 && !loading && (
                                <div className={styles.noMatches}>No merchant groups found</div>
                            )}
                            {loading ? (
                                <div className={styles.noMatches}>Loading merchant groups...</div>
                            ) : (
                                <>
                                    {/*
                                      When editing and the user has entered a search term,
                                      don't show the 'Select a merchant group' placeholder item
                                      alongside search results.
                                    */}
                                    {!(edit && searchTerm && String(searchTerm).trim() !== '') && (
                                        <Dropdown.Item
                                            key="none"
                                            active={!value}
                                            onClick={() => onChange({ target: { name: 'selectedMerchantGroupId', value: '' } })}
                                        >
                                            {/* Select a merchant group */}
                                        </Dropdown.Item>
                                    )}

                                    {merchantGroups.map((group) => (
                                        <Dropdown.Item
                                            key={group.id}
                                            active={String(value) === String(group.id)}
                                            onClick={() => onChange({ target: { name: 'selectedMerchantGroupId', value: group.id } })}
                                        >
                                            {/* show id and description if available */}
                                            {group.id}{group.description ? ` - ${group.description} (${group.name})` : ` (${group.name})`}
                                        </Dropdown.Item>
                                    ))}
                                </>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </Col>
        </Form.Group>
    );
};

export default MerchantGroupSelect;
